import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {BooleanField, FieldReturn} from '../../types'

const defaultProps: Partial<BooleanField> = {
  initialValue: false,
}

export const boolean = (props?: BooleanField, mergeProps?: Partial<BooleanField>): FieldReturn =>
  field('boolean', mergeConfig('boolean', props, mergeProps, defaultProps))
